export default __webpack_public_path__ + "static/media/plus_white.f13d4882.svg";